import { memo, useState } from "react";
import { Box } from "@mui/material";

import BSZHeader from "./appHeader/BSZHeader";
import BSZContent from "./BSZContent";

/**
 * =========================================================
 * ✅ BSZ BODY
 * =========================================================
 */
function BSZBody() {
  const [viewMode, setViewMode] = useState("all"); // future use

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {/* ✅ HEADER (fixed) */}
      <BSZHeader viewMode={viewMode} setViewMode={setViewMode} />

      {/* ✅ SCROLLABLE CONTENT */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          pb: "3rem",
        }}
      >
        <BSZContent viewMode={viewMode} />
      </Box>
    </Box>
  );
}

export default memo(BSZBody);
